export const iconFontAwesomeHandsHandHoldingDroplet = (
	<i className="fa-solid fa-hand-holding-droplet"></i>
);
